import type { ReactNode } from 'react';
import { ThemeProvider, type Theme } from '@mui/material/styles';
import { useFeature } from '../featureFlags/FeatureGate';
import { FEATURE_AUTO_LIST_FILTERS } from './listMemoryStore';

/**
 * Bez „Zapisz obecne filtry” na wszystkich listach, gdy filtry zapamiętują
 * się same (przełącznik `autoListFilters`, decyzja użytkownika 19.10.2026:
 * „powinno się to robić automatycznie, czyli można ukryć”).
 *
 * Jedno miejsce zamiast każdej listy: `FilterButton` react-admina czyta
 * domyślne propsy z motywu (`RaFilterButton`), także ten wstawiany przez
 * domyślny pasek akcji listy. Ustawiamy `disableSaveQuery` w motywie
 * zagnieżdżonym wokół ekranów. Listę zapisanych zapytań chowa magazyn
 * (`listMemoryStore.ts`) — przy przełączniku jej nie oddaje.
 *
 * „Widoki” banku zleceń (Etap 1 makiety FTL) to osobny przycisk — bez zmian.
 * Bez przełącznika — dzieci bez dodatkowego motywu, jak dotąd.
 */
export function withoutSavedQueries(outer: Theme): Theme {
  const current = outer.components?.RaFilterButton;
  return {
    ...outer,
    components: {
      ...outer.components,
      RaFilterButton: {
        ...current,
        defaultProps: { ...current?.defaultProps, disableSaveQuery: true },
      },
    },
  };
}

export const AutoListFilters = ({ children }: { children: ReactNode }) => {
  const on = useFeature(FEATURE_AUTO_LIST_FILTERS);
  return on ? <ThemeProvider theme={withoutSavedQueries}>{children}</ThemeProvider> : <>{children}</>;
};
